export enum UploadForm {
  formdata = 0,
  base64 = 1,
}
